import React, { useState } from "react";
import { useSpeechRecognition } from "react-speech-kit";

import VoiceAssistantIcon from "./VoiceAssistantIcon";
import VoiceCommands from "./VoiceCommands";

const VoiceAssistant = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [command, setCommand] = useState("");

  const { listen, listening, stop } = useSpeechRecognition({
    onResult: (result) => {
      setCommand(result);
    },
  });

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (!listening) {
      listen();
    } else {
      stop();
      setCommand("");
    }
  };

  return (
    <div>
      {isOpen && <VoiceCommands command={command} />}
      <VoiceAssistantIcon onClick={toggleChat} />
    </div>
  );
};

export default VoiceAssistant;
